import { render, staticRenderFns } from "./SchoolReportsView.vue?vue&type=template&id=1a483d44&"
import script from "./SchoolReportsView.vue?vue&type=script&lang=js&"
export * from "./SchoolReportsView.vue?vue&type=script&lang=js&"
import style0 from "./SchoolReportsView.vue?vue&type=style&index=0&id=1a483d44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports